exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Avatar{width:48px;height:48px;border-radius:calc(48px / 2);overflow:hidden}", ""]);
